export enum EnvironmentTypes {
  Production = 'Production',
  Development = 'Development',
  Sandbox = 'Sandbox',
}
